import { Theme } from '../Theme'

import { SIZES as ICON_SIZES } from '../Icon/constants'
import { IconColors } from '..'

export const mapThemedIconSize: Record<Theme, (typeof ICON_SIZES)[keyof typeof ICON_SIZES]> = {
  [Theme.AP]: ICON_SIZES.SMALL,
  [Theme.Pegasus]: ICON_SIZES.SMALL,
  [Theme.Kelpie]: ICON_SIZES.SMALL,
  [Theme.Cash]: ICON_SIZES.SMALL,
}

export const mapThemedPasswordToggleIconSize: Record<Theme, (typeof ICON_SIZES)[keyof typeof ICON_SIZES]> = {
  [Theme.AP]: ICON_SIZES.SMALL,
  [Theme.Pegasus]: ICON_SIZES.MEDIUM,
  [Theme.Kelpie]: ICON_SIZES.MEDIUM,
  [Theme.Cash]: ICON_SIZES.MEDIUM,
}

export const mapThemedPaymentIconSize: Record<Theme, (typeof ICON_SIZES)[keyof typeof ICON_SIZES]> = {
  [Theme.AP]: ICON_SIZES.MEDIUM,
  [Theme.Pegasus]: ICON_SIZES.SMALL,
  [Theme.Kelpie]: ICON_SIZES.SMALL,
  [Theme.Cash]: ICON_SIZES.SMALL,
}

export const mapThemedIconColor: Record<
  Theme,
  {
    default: IconColors | undefined
    error: IconColors | undefined
  }
> = {
  [Theme.AP]: {
    default: undefined,
    error: undefined,
  },
  [Theme.Pegasus]: {
    default: 'Subtle',
    error: 'Danger',
  },
  [Theme.Kelpie]: {
    default: 'Subtle',
    error: 'Danger',
  },
  [Theme.Cash]: {
    default: 'Subtle',
    error: 'Danger',
  },
}

export const mapThemedShouldRenderErrorIcon: Record<Theme, boolean> = {
  [Theme.AP]: false,
  [Theme.Pegasus]: true,
  [Theme.Kelpie]: true,
  [Theme.Cash]: true,
}
